import programs from './programs';
import programsGoals from './programs-goals';
import programsModules from './programs-modules';
import programsUsers from './programs-users';
import programJourneys from './program-journeys';
import programsGoalsBadges from './goals-badges';
import programsTasksBadges from './tasks-badges';


export default {
  ...programs,
  ...programsGoals,
  ...programsModules,
  ...programsUsers,
  ...programJourneys,
  ...programsGoalsBadges,
  ...programsTasksBadges,
};
